export { HeadingSection, HeadingSectionProps } from './HeadingSection'
